import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.85, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  return (
    <span ref={ref} className={`block overflow-hidden ${className}`}>
      <motion.span
        className="block will-change-transform"
        initial={false}
        animate={{ y: inView ? "0%" : "115%" }}
        transition={{ duration: 0.9, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
};

export const SectionTag = ({ no, label, dark = false }) => (
  <Reveal>
    <div className={`flex items-center gap-4 font-display text-[10px] font-bold uppercase tracking-[0.35em] md:text-xs ${dark ? "text-paper/50" : "text-ink/50"}`}>
      <span className={dark ? "text-ember" : "text-burgundy"}>{no}</span>
      <span className={`h-px w-10 ${dark ? "bg-paper/30" : "bg-ink/30"}`} />
      <span>{label}</span>
    </div>
  </Reveal>
);
